import { render, staticRenderFns } from "./EditUnplannedLeaveRow.vue?vue&type=template&id=84910be8"
import script from "./EditUnplannedLeaveRow.vue?vue&type=script&lang=js"
export * from "./EditUnplannedLeaveRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports